/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { BulkSelection } from './bulkSelection';

/**
 * Export the ranked results of a finished/in-progress arbitrator session.
 */
export interface ArbitratorSessionExportSourceSchema {
  type?: 'arbitrator_session';
  session_id: string;
  bulk: BulkSelection;
  min_score?: number | null;
  q?: string | null;
}
